import classNames from "classnames/bind";
import React from "react";
import styles from "./ControlLabel.module.scss";
import { ControlLabelProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A wrapper component that enforces label and spacing for a control not bound to a form
 */
const ControlLabel = ({
  label,
  children,
  className,
  style,
}: ControlLabelProps) => {
  return (
    <div
      className={className ?? ""}
      style={style}
    >
      <div className={cx("label")}>{label}</div>

      {children}
    </div>
  );
};

export default ControlLabel;
